import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { ContentItemContainer, Header2 } from "./LandingPageStyles";
import video_landing from "../../assets/Room/video_landing.svg";
import audio from "../../assets/Room/audio.svg";
import bluetooth from "../../assets/Room/bluetooth.svg";
import audio_mic from "../../assets/Room/audio_mic.svg";

export const DUContent = () => {
  return (
    <>
      <Header2 aria-label="Get an interpreter">Get an interpreter</Header2>

      <ContentItemContainer>
        <LazyLoadImage src={video_landing} alt="Convo video" effect="blur" />
        <span>Grant access to your camera and microphone.</span>
      </ContentItemContainer>

      <ContentItemContainer>
        <LazyLoadImage src={audio} alt="Convo video" effect="blur" />
        <span>Increase your phone’s speaker volume.</span>
      </ContentItemContainer>

      <ContentItemContainer>
        <LazyLoadImage src={bluetooth} alt="Convo video" effect="blur" />
        <span>Disconnect Bluetooth for hearing aids or implants.</span>
      </ContentItemContainer>
    </>
  );
};

export const HUContent = () => {
  return (
    <>
      <Header2 aria-label="Get an interpreter">
        Use your phone to talk and listen
      </Header2>

      <ContentItemContainer>
        <LazyLoadImage
          style={{ display: "flex" }}
          src={audio_mic}
          alt="Convo video"
          effect="blur"
        />
        <span>Grant access to your microphone</span>
      </ContentItemContainer>

      <ContentItemContainer>
        <LazyLoadImage
          style={{ display: "flex" }}
          src={audio}
          alt="Convo video"
          effect="blur"
        />
        <span>Talk and listen through the interpreter</span>
      </ContentItemContainer>
    </>
  );
};
